<template>
  <div class="dialog_wrap" @click="closeDialog">
    <div class="dialog_wrap_long" @click.stop="noTouch">
      <div class="dialog_wrap_close" @click="closeDialog"></div>
      <div class="dialog_wrap_content">
        <div class="wrap_content_title">活动规则</div>
        <div class="wrap_content_desc">
          活动时间：即日起截止至正式公测当天<br>
          玩法规则：<br>
          1、活动期间，掌门完成指定任务即可获得一次抽奖机会，最高可获得7次抽奖机会<br>
          2、掌门可以通过【邀请好友】按钮生成专属邀请链接，每有一位好友通过专属邀请链接完成预约，即视为完成一次任务同时获得一次抽奖机会，每位掌门最多可通过邀请好友获得6次抽奖机会;<br>
          3、掌门可以通过【奖励记录】查看已经兑换的奖励内容，所获得的礼包码仅限于游戏正式公测后官方服务器下角色使用，仅限兑换一次，不可用于其他渠道服；<br>
          4、实物奖励领取方式：请获得实物奖励的玩家于【奖励记录】填写收件信息，逾期未填写或误填收件信息视为放弃奖励资格。核对信息后工作人员将尽快进行邮寄，请认真核查邮寄地址与个人信息，由于信息输入错误导致周边无法放发或发放错误的，将不予补发<br>
          <el-table :data="awards" border style="width: 100%">
            <el-table-column prop="name" label="奖品名称"></el-table-column>
            <el-table-column prop="rate" label="中奖概率" width="100">
              <template slot-scope="scope">{{ (scope.row.rate*100 + "%") }}</template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AwardRule',
  props: {
    isShow: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(['awards'])
  },
  data () {
    return {}
  },
  mounted () {
    document.getElementsByTagName('body')[0].classList.add('noscroll');
  },
  beforeDestroy () {
    document.getElementsByTagName('body')[0].classList.remove('noscroll');
  },
  methods: {
    noTouch () {

    },
    closeDialog () {
      if (this.$route.name === 'reservation') {
        this.$emit('onClose', true)
      } else {
        this.$router.push({ name: 'reservation', query: this.$route.query })
      }
    }
  }
}
</script>

<style lang="scss">

</style>
